module.exports = __webpack_public_path__ + "pm.b3fe124eeb3ff2c5e148.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pm.svg
// module chunks = styles